import { useTranslation } from "react-i18next";
import CustomInputField from "components/common/CustomInputField";
import React, { useState } from "react";
import { Form, Modal } from "reactstrap";
import { ErrorToaster } from "components/common/toast";
import handleError from "utils/handleError";
import { useFormik } from "formik";
import BtnCustom from "components/common/btn-custom";
import { successToaster } from "components/common/toast";
import { SubCategorySchema } from "components/schema/SubCategorySchema";
import { CreateSectionSubCategoriesAPI } from "network/categoryAPI";
import { UpdateSectionSubCategoriesAPI } from "network/categoryAPI";

const AddSubCategorySectionModal = ({
  open,
  setOpen,
  data,
  setData,
  setFetchTrigger,
  section,
  setSubCategoriesData,
}) => {
  const { t } = useTranslation("common");
  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      name: data?.name || "",
      description: data?.description || "",
    },
    enableReinitialize: true,
    validationSchema: SubCategorySchema,

    onSubmit: async (values) => {
      try {
        if (data?.uuid) {
          const response = await UpdateSectionSubCategoriesAPI(
            section?.uuid,
            data?.uuid,

            values
          );
          if (response.success) {
            setSubCategoriesData((prev) =>
              prev.map((item) =>
                item?.uuid === response?.data?.uuid ? response?.data : item
              )
            );
            successToaster(response.message);
            resetForm();
            setOpen(false);
          }
        } else {
          const response = await CreateSectionSubCategoriesAPI(
            section?.uuid,
            values
          );
          if (response.success) {
            successToaster(response.message);
            resetForm();
            setFetchTrigger((prev) => !prev);
            setOpen(false);
          }
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });
  const handleCloseModel = () => {
    setData(null);
    resetForm();
    setOpen(false);
  };
  return (
    <div>
      <Modal isOpen={open} toggle={handleCloseModel} className="modal-md">
        <div className="modal-header">
          <h5 className="modal-title text-capitalize" id="exampleModalLabel">
            {data?.uuid ? t("subCategoryModal.updateTitle") : t("subCategoryModal.addTitle")}
          </h5>
          <button
            aria-label={t("actions.close")}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={handleCloseModel}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleSubmit}>
            {/* <CustomPaginatedSelect
              label="Select Category"
              name="categories"
              placeholder="Select Category"
              value={values.categories}
              onChange={(value) => setFieldValue("categories", value)}
              onBlur={() => setFieldTouched("categories", true)}
              touched={touched}
              errors={errors}
              loadOptions={loadCategoryOptions}
              isMulti
              colorCode="#222a42"
            /> */}

            <CustomInputField
              label={t("subCategoryModal.name")}
              name="name"
              placeholder={t("subCategoryModal.name")}
              type="text"
              errors={errors}
              touched={touched}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values}
            />

            <CustomInputField
              label={t("categoryModal.description")}
              name="description"
              placeholder={t("categoryModal.description")}
              type="textarea"
              errors={errors}
              touched={touched}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values}
            />
            <BtnCustom
              className="btn-round"
              color="primary"
              size="lg"
              type="submit"
              isLoading={isSubmitting}
              onClick={handleSubmit}
              submittingText={data?.uuid ? t("actions.updating") : t("actions.adding")}
            >
              {data?.uuid ? t("subCategoryModal.updateTitle") : t("subCategoryModal.addButton")}
            </BtnCustom>
          </Form>
        </div>
      </Modal>
    </div>
  );
};
export default AddSubCategorySectionModal;
